import { group } from '@angular/animations';
import { DecimalPipe } from '@angular/common';
import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChange, SimpleChanges, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Subject, takeUntil, debounceTime, take } from 'rxjs';
import { GenericDD } from 'src/app/model/generic-data';
import { DropdownServiceService } from 'src/app/services/dropdown-service.service';
import { CustomDialogComponent } from '../custom-dialog/custom-dialog.component';
import { FieldConfig } from '../dynamic-form/dynamicForm.interface';
import { CustomItemSelectorOptions, CustomItemSelectorModel } from './custom-item-selector';
import { CustomItemSelectorService } from './custom-item-selector.service';
import { CustomDialogOptions } from '../custom-dialog/custom-dialog';
import * as _ from 'lodash';
import { slideDownUp } from '../global-app-animations';
import { MatSelect } from '@angular/material/select';


@Component({
    selector: 'app-custom-item-selector',
    templateUrl: './custom-item-selector.component.html',
    styleUrls: ['./custom-item-selector.component.scss'],
    animations: [slideDownUp],
    standalone: false
})
export class CustomItemSelectorComponent implements OnInit, OnDestroy, AfterViewInit, OnChanges {

  @Input() options: CustomItemSelectorOptions | undefined;
  @Input() placeholder: string | undefined;
  @Input() field: FieldConfig | undefined;
  @Input() group!: FormGroup;
  @ViewChild('dialogKit') kitDialog!: CustomDialogComponent;
  @ViewChild('inputEl') inputEl!: MatSelect;
  

  //events
  @Output() onChanges: EventEmitter<any> = new EventEmitter<any>();
  @Output() onDialoClose: EventEmitter<any> = new EventEmitter<any>();


  dataSourceOriginal: CustomItemSelectorModel[] = [];
  dataSource: CustomItemSelectorModel[] = [];
  dataSourceFiltered: CustomItemSelectorModel[] = [];

  selected: string = '';
  selectedId: number | undefined = undefined;

  selectedIdArray: Array<number> = [];

  takeVals: boolean = true;  
  
  selectedAll: boolean = false;

  parsedOptions: CustomItemSelectorOptions = {
    popupLabel: '',
    selectType: 'single',
  };

  dialogOptions: CustomDialogOptions = {
    closeOnOutsideClick: true,
    height: '90vh',
  }

  constructor(private cisService: CustomItemSelectorService, private deciPipe: DecimalPipe) {


  }

  private theEnd$: Subject<void> = new Subject<void>()
  filter$: Subject<void> = new Subject<void>()
  //FAI IN MODO CHE IL VALORE DEL FILTRO VENGA SALVATO DENTRO OPTIONS IN UN CAMPO VALUE, USALO COME NGMODEL E ONCHANGE CAMBI IL VALORE E TRIGGERI I SUBJECT
  private scroll$: Subject<number> = new Subject<number>()

  //pagination things
  private offset: number = 0;
  private max: number = 25;
  private filter: string = "";
  endOfPagination: boolean = false;
  firstLoad: boolean = true;
  loading: boolean = false; //recreates the dropdown everytime the dataSource changes

  offlineFilterValue: string = '';


  ngOnInit(): void {
    // set options 
    if (this.options != undefined) {

      if(this.options.listOnly == undefined){
        this.options.listOnly = true;
      }
      
      this.parsedOptions = this.options;

    }

    if (this.options && this.options.itemsToShow) {
      this.max = this.options.itemsToShow;
      this.selected = this.options.popupLabel;
    }

    if (!this.field) {
      this.max = this.parsedOptions.itemsToShow ?? 50;
      this.selected = this.parsedOptions.popupLabel;
    }

    if (this.field && this.group) {
      //console.error(`\n \n \n \n \n THIS IS THE FIELD VALUE: ${this.field.name}, ${this.field.label}  \n \n \n \n`);
      //console.error(this.field.value);
      if (this.options?.selectType == 'single') {
        //        console.error("\n \n \n IN THA IF 1 \n \n \n");

        //console.error("\n \n \n IN THA IF 2 \n \n \n");
        if(this.field.value != undefined){
    
          this.group.controls[this.field!.name].markAsTouched();
          
          this.selectedId = this.field.value;
          if(this.selectedId){

            this.selectedIdArray.push(this.selectedId);
          }
        }else{
          this.selectedIdArray = [];
        }


      } else if (this.options?.selectType == 'multiple') {
        if (this.field.value != undefined) {
          this.group.controls[this.field!.name].markAsTouched();
          this.selectedIdArray = this.field.value;
        }
      }
      let resetFormFunc = this.group.reset;

      

      this.group.reset = () => {
        resetFormFunc.apply(this.group)
        this.field!.value = undefined;
        this.selected = this.options?.popupLabel || '';
        this.dataSource.forEach(elem => {
          elem.selected = false;
        })
      }
    }

    //console.error(`\n \n \n Now this is the value of the selected item: ${this.selectedId} \n \n \n`);

    //SCROLL SUBJECT
    this.scroll$.pipe(takeUntil(this.theEnd$), debounceTime(500)).subscribe({
      next: (val: number) => {
        //console.warn("subbed " + val);
        //console.error(this.selectedIdArray)
        if (val >= 98 && !this.endOfPagination) {
          this.loadSetData();
        }
      }
    })

    //FILTER SUBJECT

    this.filter$.pipe(takeUntil(this.theEnd$), debounceTime(500)).subscribe({
      next: () => {
        if(this.parsedOptions.offlineFilter){
          if(this.offlineFilterValue.length > 0){

            this.dataSource = this.dataSourceOriginal.filter(x=> x.codice.toLowerCase().includes(this.offlineFilterValue.toLowerCase()));
          }else{
            this.dataSource = _.cloneDeep(this.dataSourceOriginal);
          }


        }else{

          this.offset = 0;
          this.endOfPagination = false;
          this.filter = '';
          this.takeVals = true;
          this.options?.filters?.forEach(filter => {
            if (filter.value != undefined) {
              this.filter += `&${filter.filterName}=${filter.value}`;
            }
          })
  
          this.cisService.GenericDDWithIsc(`${this.options!.url}`, this.offset, this.max, this.selectedIdArray, this.takeVals, this.filter).pipe(takeUntil(this.theEnd$)).subscribe({
            next: (data: CustomItemSelectorModel[]) => {
              this.dataSource = [];
              this.takeVals = false;
              if (data.length == 0) {
                this.endOfPagination = true;
              } else {
                data.forEach(val => {
  
                  if (this.field && this.group) {
                    if (this.parsedOptions.selectType == 'single') {
                      if (val.id == Number(this.selected)) {
                        val.selected = true;
                      } else {
                        val.selected = false
                        this.selectedId = undefined;
                      }
                    } else if (this.parsedOptions.selectType == 'multiple') {
                      if (this.selectedIdArray.find(x => x == val.id)) {
                        val.selected = true;
                      } else {
                        val.selected = false
                        //this.currentValue;
                      }
                    }
                  } else {
                    if (this.parsedOptions.selectType == 'single') {
                      if (val.id == Number(this.selected)) {
                        val.selected = true;
                      } else {
                        val.selected = false
                        this.selectedId = undefined;
                      }
                    } else if (this.parsedOptions.selectType == 'multiple') {
                      if (this.selectedIdArray.find(x => x == val.id)) {
                        val.selected = true;
                      } else {
                        val.selected = false
                        //this.currentValue;
                      }
                    }
                  }
  
                  this.dataSource.push(val)
                })
              }
  
              this.dataSource = this.dataSource.sort((a, b) => {
                return (a.selected === b.selected) ? 0 : a.selected ? -1 : 1;
              });
  
              if (this.dataSource.length < this.max) {
                //console.log("ULTRAGAY")
                this.endOfPagination = true;
              }

              this.offset += this.max;
  
              this.changeLabel()
  
  
            }
          });
        }

      }
    })


    this.scroll$.next(100);
  }

  loadSetData() {
    this.cisService.GenericDDWithIsc(`${this.options!.url}`, this.offset, this.max, this.selectedIdArray, this.takeVals, this.filter).pipe(take(1)).subscribe({
      next: (data: CustomItemSelectorModel[]) => {
        
        this.takeVals = false;
        if (data.length == 0) {
          this.endOfPagination = true;
        }


        data.forEach(val => {

          if (this.field && this.group) {
            if (this.parsedOptions.selectType == 'single') {
              if (val.id == this.selectedIdArray[0]) {
                val.selected = true;
                if(this.group != undefined) {
                  this.group.controls[this.field!.name].markAsTouched();
                }
              } else {
                val.selected = false
              }
            } else if (this.parsedOptions.selectType == 'multiple') {
              if (this.selectedIdArray.find(x => x == val.id)) {
                val.selected = true;
                if(this.group != undefined) {
                  this.group.controls[this.field!.name].markAsTouched();
                }
              } else {
                val.selected = false
                //this.currentValue;
              }
            }
          } else {
            if (this.parsedOptions.selectType == 'single') {
              if (val.id == this.selectedIdArray[0]) {
                val.selected = true;
                if(this.group != undefined) {                  
                  this.group.controls[this.field!.name].markAsTouched();
                }
              } else {
                val.selected = false
              }
            } else if (this.parsedOptions.selectType == 'multiple') {
              if (this.selectedIdArray.find(x => x == val.id)) {
                val.selected = true;
              } else {
                val.selected = false
                //this.currentValue;
              }
            }
          }

          this.dataSource.push(val)

          //console.log(val)
        })

        if (this.group) {
          if (this.parsedOptions.selectType == 'single') {

            this.group.controls[this.field!.name].setValue(this.selectedId);

          } else if (this.parsedOptions.selectType == 'multiple') {

            this.group.controls[this.field!.name].setValue(this.selectedIdArray);
          }
        }


        if (this.options != undefined && this.options.pagination != undefined && this.options.pagination == false) {
          this.endOfPagination = true;
        }

        if (this.dataSource.length < this.max) {
          this.endOfPagination = true;
        }

        this.offset += this.max;


        this.dataSource = this.dataSource.sort((a, b) => {
          return (a.selected === b.selected) ? 0 : a.selected ? -1 : 1;
        });


        this.dataSourceOriginal = _.cloneDeep(this.dataSource);

        this.changeLabel()
      }
    });
  }

  ngOnDestroy(): void {
        this.theEnd$.next();
    this.theEnd$.complete();
  }

  ngAfterViewInit(): void {
  }

  ngOnChanges(changes: { options: SimpleChange, field: SimpleChange }): void {

    if (changes.options) {
      //console.error("\n \n \n \n \n AYOOOOOOOOOOOOOOO THE FKNG OPTIONS CHANGED \n \n \n \n \n");
      //console.error(changes.options.currentValue);
      //this.parsedOptions = changes.options.currentValue;
      this.options = changes.options.currentValue;
    }

    if (changes.field) {
      this.selectedId = changes.field.currentValue.value;
      this.scroll$.next(100);
    }

  }

  selectItem(item: CustomItemSelectorModel) {

    /*if(item.active == false) {
      return;
    }*/

    this.loading = true;

    if(this.group != undefined) {
      this.group.controls[this.field!.name].markAsTouched();
    }

    this.dataSource.forEach(elem => {
      if (elem.id == item.id) {
        if (elem.selected == true) {
          this.selected = this.options!.popupLabel;
          //this.selected = this.parsedOptions.popupLabel;
          if (this.field) {
            this.field!.value = undefined;
          }
          elem.selected = false;

          if (this.parsedOptions.selectType == 'single') {
            this.selectedId = undefined;
            let i = this.selectedIdArray.findIndex(x => x == elem.id);
            if (i > -1) {
              this.selectedIdArray.splice(i, 1);
            }
            this.onChanges.emit({ field: this.field?.name, value: this.selectedId, stringValue: this.selected });

          } else if (this.parsedOptions.selectType == 'multiple') {
            let i = this.selectedIdArray.findIndex(x => x == elem.id);
            if (i > -1) {
              this.selectedIdArray.splice(i, 1);
            }

            this.onChanges.emit({ field: this.field?.name, value: this.selectedIdArray, stringValue: this.selected });
          }

        } else {
          elem.selected = true;

          if (this.field) {
            this.field!.value = Number(elem.id);
          }
          if (this.parsedOptions.selectType == 'single') {

            this.selected = elem.codice;
            this.selectedId = elem.id;
            this.selectedIdArray = [];
            this.selectedIdArray.push(...[elem.id]);

            this.onChanges.emit({ field: this.field?.name, value: this.selectedId, stringValue: this.selected });

          } else if (this.parsedOptions.selectType == 'multiple') {

            this.selectedIdArray.push(...[elem.id]);


            this.selected = '';



          }
        }

        if (this.group) {
          if (this.parsedOptions.selectType == 'single') {

            this.group.controls[this.field!.name].setValue(this.selectedId);

          } else if (this.parsedOptions.selectType == 'multiple') {

            this.group.controls[this.field!.name].setValue(this.selectedIdArray);
          }
        }
        //this.onChanges.emit(elem);
      } else {
        if (this.parsedOptions.selectType == 'single') {
          elem.selected = false;
        }
      }
    })


    this.changeLabel()

    // if close on click true close on click
    if(this.parsedOptions.closeOnClick == true) {
      this.kitDialog.close();
    }

  }

  selectAll() {
    this.loading = true;
    this.selectedAll = true;
    this.selectedIdArray = [];
    this.dataSource.forEach(elem => {

    
      elem.selected = true;

      this.selectedIdArray.push(...[elem.id]);


      this.selected = '';

      if (this.group) {
        if (this.parsedOptions.selectType == 'multiple') {

          this.group.controls[this.field!.name].setValue(this.selectedIdArray);
        }
      }
      //this.onChanges.emit(elem);

    })


    this.changeLabel()

  }

  unselectAll() {
    this.loading = true;
    this.selectedAll = false;
    this.selectedIdArray = [];
    this.dataSource.forEach(elem => {

      elem.selected = false;

      this.selected = '';

      if (this.group) {
        if (this.parsedOptions.selectType == 'multiple') {

          this.group.controls[this.field!.name].setValue(this.selectedIdArray);
        }
      }
      //this.onChanges.emit(elem);

    })

    

    this.changeLabel()

  }

  dialogCloesed(event: any) {

    let data = {
      data: this.selectItem,
    };

    this.onDialoClose.emit(data);
  }

  onScroll(event: any) {
    if (this.endOfPagination == false) {
      let target = event.target as HTMLElement;
      this.scroll$.next(Number(this.deciPipe.transform((target.scrollTop) / (target.scrollHeight - target.clientHeight) * 100, '1.0-0')));
    }


  }

  loadRequiredData(event: any) {
    //this.loadSetData();
  }

  changeLabel() {

    let realSelectedString = '';
    if (this.selectedIdArray.length > 0) {
      this.selected = '';


      //console.error(`\n \n \n Setting label for: ${this.field?.name}, ${this.field?.label} \n \n \n`);

      //console.error(`\n \n \n this is dataSource length: ${this.dataSource.length} \n \n \n`);

      let selectedItems = this.dataSource.filter(x => this.selectedIdArray.includes(x.id))

      //console.error(`\n \n \n this are the foun items: ${selectedItems.length} \n \n \n`);

      if (selectedItems.length > 0) {
        this.selected += `${selectedItems[0].codice}`;
        realSelectedString = this.selected;

        if (selectedItems.length > 1) {
          realSelectedString = '';
          this.selected += ` + altri ${selectedItems.length - 1} elementi`

          selectedItems.forEach((elem, i) => {
            if ((i + 1) < selectedItems.length) {

              realSelectedString += `${elem.codice},`
            } else {
              realSelectedString += `${elem.codice}`
            }

          })
        }

      }

      this.onChanges.emit({ field: this.field?.name, value: this.selectedIdArray, stringValue: realSelectedString });
    } else {
      this.selected = this.options!.popupLabel;
      this.onChanges.emit({ field: this.field?.name, value: this.selectedIdArray, stringValue: '' });
    }



  }

  filterValueChange(event: any, filterName: string) {
    this.options!.filters!.find(x => x.filterName == filterName)!.value = event.id;
    this.filter$.next();
  }


  offlineFilter() {
    this.filter$.next();
  }


  resetValue() {
    this.field!.value = undefined;
    this.selected = this.options?.popupLabel || '';
    this.dataSource.forEach(elem => {
      elem.selected = false;
    })
  }


  getSVG(svg: any) {
    return btoa(svg)
  }


}

